import moment from "moment";
import React from "react";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import { FilterDatePicker } from "components/DatePicker/SingleDatePicker";
import { Input } from "semantic-ui-react";

export interface LifeCycleValue {
  lifeCycle: server.dto.DocumentLifeCycle;
  completed: moment.Moment;
  reason: string;
}

interface Props {
  value: LifeCycleValue;
  onChange: (value: LifeCycleValue) => void;
}

export const ChooseLifecycle = (props: Props) => {
  const { value, onChange } = props;

  const options: server.dto.DocumentLifeCycle[] = [
    { value: "pending", text: RESX.DocumentLifeCycle.OutForSignature },
    { value: "completed", text: RESX.DocumentLifeCycle.Completed },
    { value: "discarded", text: RESX.DocumentLifeCycle.Discarded }
  ];

  return (
    <div className="flex-column gap-small">
      <BaseReactSelectDropdown
        options={options}
        value={value.lifeCycle}
        onChange={(lifeCycle) => {
          let newCompleted: moment.Moment;
          const oldLifecycle = value.lifeCycle.value;
          const newLifecycle = lifeCycle.value;

          // If changing from pending to a different lifecycle, set completed to today as a default
          if (oldLifecycle === "pending" && newLifecycle !== "pending") {
            newCompleted = moment.utc().startOf("day");
          }
          // If changing to back pending, clear completed date
          else if (oldLifecycle !== "pending" && newLifecycle === "pending") {
            newCompleted = null;
          }
          else {
            newCompleted = value.completed;
          }
          onChange({
            ...value, lifeCycle,
            completed: newCompleted
          })
        }}
        getLabel={(lifecycle) => lifecycle.text}
        getValue={(lifecycle) => lifecycle.value}
        config={{}}
        excludeKeys={[]}
      />
      {value.lifeCycle?.value !== "pending" && (<>
        <div>
          <FilterDatePicker
            minDate={moment.utc().subtract(10, "year")}
            maxDate={moment.utc().add(10, "year")}
            value={value.completed}
            onChange={(completed) => {
              onChange({ ...value, completed });
            }}
          />
        </div>
        <div>
          <Input
            fluid
            value={value.reason || ""}
            placeholder={RESX.GeneralLabels.Comment}
            maxLength={50}
            onChange={(_, data) => {
              onChange({ ...value, reason: data.value });
            }}
          />
        </div>
      </>
      )}
    </div>
  );
};

export default ChooseLifecycle;
